import utils from 'utils';

export const api = {
    panas: {
        getOrders: (date: Date, showPrevious: boolean) => {
            return utils.post('getOrders', {
                date: date.getTime(),
                showPrevious,
            });
        },
        getOrder: (id: string) => {
            return utils.fetch('getOrder/' + id);
        },
        getProducts: (date: Date) => {
            return utils.post('getProducts', {date: date.getTime()});
        },
        getProduct: (name: string, date: Date) => {
            return utils.post('getProduct', {name, date: date.getTime()});
        },
        updateOrder: (id: string, data) => {
            return utils.post('updateOrder/' + id, {data});

            // todo: get status
        },
        updateProducts: (data) => {
            return utils.post('updateProducts', {data});

            // todo: get status
        },
        getProductsStatsByMonth: (date: Date) => {
            return utils.post('getProductsStatsByMonth', {date: date.getTime()});
        },
        getAdditionalPayments: () => {
            return utils.fetch('getAdditionalPayments');
        },
    },
};

export {useApiQuery} from './useApiQuery';
